import type { ReactNode } from "react";
import type { Icon } from "@phosphor-icons/react";
import { cn } from "./cn";

/**
 * What a list shows when it has nothing to list: an icon, one line saying so,
 * a line on what to do about it, and optionally the action.
 */
export function EmptyState({
  icon: EmptyIcon,
  title,
  description,
  action,
  className,
}: {
  icon?: Icon;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center px-6 py-14 text-center",
        className
      )}
    >
      {EmptyIcon && (
        <span className="mb-3 inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-muted text-muted-foreground">
          <EmptyIcon className="h-6 w-6" />
        </span>
      )}
      <p className="text-sm font-medium text-foreground">{title}</p>
      {description && (
        <p className="mt-1 max-w-sm text-sm text-muted-foreground">
          {description}
        </p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
